<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <!-- {{ this.$route.meta.title }} -->
        <span v-if="model.tipetrx == 'receipt'">Penerimaan Dokumen Agunan</span>
        <span v-if="model.tipetrx == 'submit'">Penyerahan Dokumen Agunan</span>
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            @click="save()"
            v-b-tooltip.hover
            title="Save data agunan"
          >
            <i class="fa fa-floppy-o"></i> {{ $t("save") }}
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left pt-0">Nama Debitur</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          v-model="model.CustName"
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left pt-0">Nomor Perjanjian Kredit</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          v-model="model.no_agreement"
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left pt-0">Nomor Pinjaman</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          v-model="model.no_kontrak"
        ></b-form-input>
      </b-input-group>
      <hr>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left pt-0">Tipe Jaminan</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          v-model="model.tipejaminantext"
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left">Nama Jaminan</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          v-model="model.namajaminan"
          placeholder="Mobil Alphard / Rumah tinggal mewah"
        ></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label class="lbl-left">Alamat Jaminan</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          v-model="model.alamat"
        ></b-form-input>
      </b-input-group>
      <b-input-group class="sub-section-input">
        <b-input-group-prepend>
          <label class="sub-section-label">Kelurahan</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          placeholder
          v-model="model.kelurahan"
        ></b-form-input>
        <b-input-group-prepend>
          <label class="sub-section-label text-right mr-2">Kecamatan</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          placeholder
          v-model="model.kecamatan"
        ></b-form-input>
      </b-input-group>
      <b-input-group class="sub-section-input">
        <b-input-group-prepend>
          <label class="sub-section-label">Kota</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          placeholder
          v-model="model.kota"
        ></b-form-input>
        <b-input-group-prepend>
          <label class="sub-section-label text-right mr-2">Propinsi</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          placeholder
          v-model="model.provinsi"
        ></b-form-input>
      </b-input-group>
      <b-input-group class="sub-section-input" style="width: calc(50% - 103px)">
        <b-input-group-prepend>
          <label class="sub-section-label">Kodepos</label>
        </b-input-group-prepend>
        <b-form-input
          class="form-control-static bg-white"
          readonly
          placeholder
          v-model="model.kodepos"
        ></b-form-input>
      </b-input-group>

      <div v-if="model.tipejaminan == 'Kendaraan'">
        <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Pemilik A/N</label>
              </b-input-group-prepend>
              <b-form-input
                class="form-control-static bg-white"
                readonly
                v-model="model.pemilikjaminan"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">No. BPKB</label>
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.bpkb"
          ></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2">No. STNK</label>
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.stnk"
          ></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status STNK</label>
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.statusstnk"
          ></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2"
              >Tanggal STNK</label
            >
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            type="date"
            v-model="model.tanggalstnk"
          ></b-form-input>
        </b-input-group>
      </div>
      <div v-if="model.tipejaminan == 'FA'">
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Luas Tanah</label>
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.luastanah"
            style="max-width: 150px"
          ></b-form-input>
          <b-input-group-append>
            <label class="ml-2 mr-5">
              /m
              <sup>2</sup>
            </label>
          </b-input-group-append>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2"
              >Luas Bangunan</label
            >
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.luasbangunan"
            style="max-width: 150px"
          ></b-form-input>
          <b-input-group-append>
            <label class="ml-2">
              /m
              <sup>2</sup>
            </label>
          </b-input-group-append>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status Sertifikat</label>
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.sertifikatstatus"
          ></b-form-input>
          <b-form-input
            v-if="model.sertifikatstatus == 'lainnya'"
            class="form-control-static bg-white"
            readonly
            v-model="model.otherstatussertifikat"
          ></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">No Sertifikat</label>
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.sertifikatno"
          ></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2" style="width:160px;"
              >Sertifikat Atas Nama</label
            >
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.pemilikjaminan"
          ></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status PBB</label>
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.statuspbb"
          ></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2" style="width:160px;">Tanggal PBB</label>
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.tanggalpbb"
          ></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend>
            <label class="lbl-left">Status Asuransi</label>
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.statusasuransi"
          ></b-form-input>
          <b-input-group-prepend>
            <label class="sub-section-label text-right mr-2" style="width:160px;">No. IMB</label>
          </b-input-group-prepend>
          <b-form-input
            class="form-control-static bg-white"
            readonly
            v-model="model.noimb"
          ></b-form-input>
        </b-input-group>
      </div>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label class="lbl-left">Nilai Jaminan</label>
            </b-input-group-prepend>
            <b-input-group-prepend>
              <label class="mr-3" style="width: 20px !important">Rp.</label>
            </b-input-group-prepend>
            <b-form-input
              class="form-control-static bg-white text-right"
              readonly
              v-model="model.nilaijaminanamt"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2" style="width:160px;"
                >Hub. Dgn Peminjam</label
              >
            </b-input-group-prepend>
            <b-form-input
              class="form-control-static bg-white"
              readonly
              v-model="model.hubungandgnpemilik"
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <br><br>
      <b-row>
        <b-col lg="12" v-if="model.tipetrx == 'receipt'">
          <b-card>
            <div slot="header">
              <h6>Penerimaan Dokumen Dari Debitur</h6>
            </div>
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Tanggal Penerimaan</label>
              </b-input-group-prepend>
              <!-- <b-form-input
                class="form-control-static bg-white text-right"
                v-model="receiptDt.nilaijaminanamt"
                type="date"
              ></b-form-input> -->
              <!-- <b-input type="date" v-model="model.receiptDt.receiptDate" :state="!$v.model.receiptDt.receiptDate.$error" /> -->
              <b-input type="date" v-model="model.tanggaltrx" :state="!$v.model.tanggaltrx.$error" />
            </b-input-group>

            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Nomor Surat</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.no_surat" :state="!$v.model.no_surat.$error"></b-form-input>
            </b-input-group>

            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Diserahkan oleh</label>
              </b-input-group-prepend>
              <!-- <b-form-input
                class="form-control-static bg-white text-right"
                v-model="receiptDt.nilaijaminanamt"
              ></b-form-input> -->
              <b-form-input v-model="model.submittedBy" :state="!$v.model.submittedBy.$error"></b-form-input>
               <!-- :state="!$v.receiptDt.submittedBy.$error" -->
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Diterima oleh</label>
              </b-input-group-prepend>
              <!-- <b-form-input
                class="form-control-static bg-white text-right"
                v-model="receiptDt.nilaijaminanamt"
              ></b-form-input> -->
              <b-form-input v-model="model.receivedBy" :state="!$v.model.receivedBy.$error"></b-form-input>
               <!-- :state="!$v.receiptDt.receivedBy.$error" -->
            </b-input-group>
            <!-- <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Disimpan oleh</label>
              </b-input-group-prepend>
              <b-form-input
                class="form-control-static bg-white text-right"
                v-model="receiptDt.nilaijaminanamt"
              ></b-form-input>
              <b-form-input v-model="model.receiptDt.savedBy"></b-form-input>
               :state="!$v.receiptDt.savedBy.$error"
            </b-input-group> -->
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Lokasi penyimpanan</label>
              </b-input-group-prepend>
              <!-- <b-form-input
                class="form-control-static bg-white text-right"
                v-model="receiptDt.nilaijaminanamt"
              ></b-form-input> -->
              <b-form-input v-model="model.location" :state="!$v.model.location.$error"></b-form-input>
               <!-- :state="!$v.receiptDt.storageLocation.$error" -->
            </b-input-group>
            <!-- <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">No Rak / Brangkas</label>
              </b-input-group-prepend>
              <b-form-input
                class="form-control-static bg-white text-right"
                v-model="receiptDt.nilaijaminanamt"
              ></b-form-input>
              <b-form-input v-model="model.receiptDt.safeNumber"></b-form-input>
               :state="!$v.receiptDt.safeNumber.$error"
            </b-input-group> -->
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Catatan</label>
              </b-input-group-prepend>
              <!-- <b-form-textarea :rows="6" :max-rows="10"></b-form-textarea> -->
              <b-form-textarea
                    id="textarea"
                    v-model="model.description"
                    placeholder="Tambahkan catatan.."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
            </b-input-group>
          </b-card>
        </b-col>
        <b-col lg="12" v-if="model.tipetrx == 'submit'">
          <b-card>
            <div slot="header">
              <h6>Penyerahan Dokumen Kpd Debitur</h6>
            </div>
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Tanggal Penyerahan Dokumen</label>
              </b-input-group-prepend>
              <!-- <b-form-input
                class="form-control-static bg-white text-right"
                v-model="receiptDt.nilaijaminanamt"
                type="date"
              ></b-form-input> -->
              <b-input type="date" v-model="model.tanggaltrx" :state="!$v.model.tanggaltrx.$error" />
               <!-- :state="!$v.submitDt.submissionDate.$error"  -->
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Nomor Surat</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.no_surat" :state="!$v.model.no_surat.$error"></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Diserahkan oleh</label>
              </b-input-group-prepend>
              <!-- <b-form-input
                class="form-control-static bg-white text-right"
                v-model="receiptDt.nilaijaminanamt"
              ></b-form-input> -->
              <b-form-input v-model="model.submittedBy" :state="!$v.model.submittedBy.$error"></b-form-input>
               <!-- :state="!$v.submitDt.submittedBy.$error" -->
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Diterima oleh</label>
              </b-input-group-prepend>
              <!-- <b-form-input
                class="form-control-static bg-white text-right"
                v-model="receiptDt.nilaijaminanamt"
              ></b-form-input> -->
              <b-form-input v-model="model.receivedBy" :state="!$v.model.receivedBy.$error"></b-form-input>
               <!-- :state="!$v.submitDt.receivedBy.$error" -->
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Lokasi penyerahan</label>
              </b-input-group-prepend>
              <!-- <b-form-input
                class="form-control-static bg-white text-right"
                v-model="receiptDt.nilaijaminanamt"
              ></b-form-input> -->
              <b-form-input v-model="model.location" :state="!$v.model.location.$error"></b-form-input>
               <!-- :state="!$v.submitDt.submissionLocation.$error" -->
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label class="lbl-left">Catatan</label>
              </b-input-group-prepend>
              <!-- <b-form-textarea :rows="6" :max-rows="10"></b-form-textarea> -->
              <b-form-textarea
                    id="textarea"
                    v-model="model.description"
                    placeholder="Tambahkan catatan.."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
            </b-input-group>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required, minValue, requiredIf } from "vuelidate/lib/validators";
toastr.init();
import jaminan from "../../apis/agunankredit";
export default {
  components: { myNumber },
  mixins: [validationMixin],
  validations: {
    model: {
      tipejaminan: { required },
      namajaminan: { required },
      tanggaltrx: { required },
      no_surat: { required },
      submittedBy: { required },
      receivedBy: { required },
      location: { required },
      // alamat: { required },
      // kelurahan: { required },
      // kecamatan: { required },
      // kota: { required },
      //provinsi: { required },
      // kodepos
      // bpkb: {
      //   required: requiredIf(function (value) {
      //     return this.ifKendaraan;
      //   }),
      // },
      // stnk: {
      //   required: requiredIf(function (value) {
      //     return this.ifKendaraan;
      //   }),
      // },
      // statusstnk: {
      //   required: requiredIf(function (value) {
      //     return this.ifKendaraan;
      //   }),
      // },
      // tanggalstnk: {
      //   required: requiredIf(function (value) {
      //     return this.ifKendaraan;
      //   }),
      // },
      // luastanah: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // luasbangunan: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // sertifikatno: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // sertifikatstatus: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // otherstatussertifikat: {
      //   required: requiredIf(function (value) {
      //     return this.ifstssrtfkother;
      //   }),
      // },
      // statusasuransi: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // tanggalpbb: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // statuspbb: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // noimb: {
      //   required: requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // pemilikjaminan: {
      //   required,
      //   : requiredIf(function (value) {
      //     return this.ifFAsset;
      //   }),
      // },
      // hubungandgnpemilik
      nilaijaminan: { required },

      // receiptDt: {
      //   receiptDate: { required },
      //   submittedBy: { required },
      //   receivedBy: { required },
      //   savedBy: { required },
      //   storageLocation: { required },
      //   safeNumber: { required },
      // },
      // submitDt: {
      //   submissionDate: { required },
      //   submittedBy: { required },
      //   receivedBy: { required },
      //   submissionLocation: { required },
      // },
      
    }, 
  },
  data() {
    return {
      model: {
        CustName: "",
        no_agreement: "",
        no_kontrak: "",
        namajaminan: "",
        alamat: "",
        kelurahan: "",
        kecamatan: "",
        kota: "",
        provinsi: "",
        kodepos: "",
        tipejaminan: "FA",
        luastanah: 0,
        luasbangunan: 0,
        sertifikatstatus: "HM",
        otherstatussertifikat: "",
        sertifikatno: null,
        pemilikjaminan: null,
        hubungandgnpemilik: null,
        noimb: null,
        statuspbb: null,
        tanggalpbb: null,
        bpkb: null,
        stnk: null,
        statusstnk: null,
        tanggalstnk: null,
        nilaijaminan: 0,
        statusasuransi: null,

        // receiptDt:{
        //   receiptDate: null,
        //   submittedBy: null,
        //   receivedBy: null,
        //   savedBy: null,
        //   storageLocation: null,
        //   safeNumber: null,
        //   note: null,
        // },
        // submitDt:{
        //   submissionDate: null,
        //   submittedBy: null,
        //   receivedBy: null,
        //   submissionLocation: null,
        //   note: null,
        // },

        tipetrx: this.$route.params.tipetrx,
        tanggaltrx: null,
        no_surat: null,
        submittedBy: null,
        receivedBy: null,
        location: null,
        description: null,
        
      },
      //issuedDt:{},
      optTipeJaminan: [
        { text: "Aset Tetap", value: "FA" },
        { text: "Kendaraan", value: "Kendaraan" },
      ],
      optStsSertifikat: [
        { text: "Hak Milik", value: "HM" },
        { text: "Hak Guna Bangunan", value: "HGB" },
        { text: "Hak Guna Usaha", value: "HGU" },
        { text: "Induk", value: "induk" },
        { text: "Lainnya", value: "lainnya" },
      ],
    };
  },
  props: [],
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    ifKendaraan() {
      return this.model.tipejaminan == "Kendaraan" ? true : false;
    },
    ifFAsset() {
      return this.model.tipejaminan == "FA" ? true : false;
    },
    ifstssrtfkother() {
      return this.model.sertifikatstatus == "lainnya" ? true : false;
    },
  },
  async created() {
    //console.log("#this.$route.params: ", this.$route.params);
    if (this.$route.params.jaminankey) {
      this.model.jaminankey = this.$route.params.jaminankey;
      this.model.tipetrx = this.$route.params.tipetrx;
      this.getdata();
    }
  },
  methods: {
    async getdata() {
      const jaminankey = this.model.jaminankey;
      const res = await jaminan.detail(jaminankey);
      // this.model = res;
      //console.log("#res: ", res);
      for (const key in res) {
        this.model[key] = res[key];
      }
      this.model.tanggalstnk =
        (this.model.tanggalstnk || "") == ""
          ? null
          : moment(this.model.tanggalstnk).format("YYYY-MM-DD");

      this.model.tanggalpbb =
        (this.model.tanggalpbb || "") == ""
          ? null
          : moment(this.model.tanggalpbb).format("YYYY-MM-DD");

      this.model.nilaijaminan = this.model.nilaijaminan.toLocaleString(
        undefined,
        { maximumFractionDigits: 2 }
      );
      this.model.tipejaminantext =
        this.model.tipejaminan == "FA" ? "Aset Tetap" : "Kendaraan";
      this.model.nilaijaminanamt = this.model.nilaijaminan;
    },
    async save() {
      if (this.invalidModel) {
        //console.log("validation : ", this.$v.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          //console.log("model obj : ", this.model);
          await jaminan.save(this.model);
          toastr.success("Data berhasil disimpan", "Info");
          this.close();
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push({ name: "loan.agunanlist" });
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  margin-top: 4px !important;
}
// .input-group {
//   margin-top: 2px;
// }
.lbl-left {
  width: 200px !important;
}
.sub-section-input {
  margin-left: 200px;
  width: calc(100% - 200px);
}
.sub-section-label {
  width: 150px;
}
.mynumb-penghasilan {
  max-width: 200px;
}
</style>